import React, { useState, useEffect } from 'react';
import { useStyles } from './styles';
import Layout from 'shared/component/Layout';
import { useAdministrators } from 'hook/administrators';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import AdminForm from 'shared/forms/AdminForm';
import { cleanPhone } from 'utils/converters';

function AdminUpdatePage() {
  const classes = useStyles();

  const { id } = useParams();
  const { getUpdate, getOne, data, loading, status } = useAdministrators();

  const [initialValues, setInitialValues] = useState(null);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (id) {
      getOne({ id });
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setTimeout(() => {
        setInitialValues({
          ...data,
          enterprise:
            data?.enterprise && Object.keys(data?.enterprise).length > 0
              ? data?.enterprise
              : { id: '' },
        });
      }, 750);
    }
  }, [data]);

  useEffect(() => {
    return () => {
      setInitialValues(null);
    };
  }, []);

  const formatRequest = (data) => ({
    name: data?.name,
    email: data?.email,
    cpf: data?.cpf,
    cell_phone: cleanPhone(data?.cell_phone),
    company: { id: data?.company.id },
    group: { id: data?.group.id },
    units: data?.units,
    check_email_admin: true,
    scale_permission: data?.scale_permission,
    scales: data?.escales,
  });

  const formSubmit = ({ data }) => {
    getUpdate({
      id,
      data: formatRequest(data),
      permissions: data?.permissions.map((item) => ({ id: item?.id })),
    })
      .then(() => {
        setMessage('Administrador editado com sucesso!');
        setError(false);
      })
      .catch((response) => {
        if (
          response.status === 400 &&
          response.data.msg.indexOf(
            'There is already a registered user with that email'
          ) !== -1
        )
          setMessage('Erro ao editar: já existe um usuário com este email.');
        else setMessage('Erro ao tentar editar o administrador.');
        setError(true);
      });
  };
  return (
    <Layout
      title="Administradores"
      isLoading={false}
      calendarWeek={false}
      showToday
      backArrow
    >
      <>
        {initialValues ? (
          <AdminForm
            formInitialValues={initialValues}
            formSubmit={formSubmit}
            loading={loading}
            status={status}
            error={error}
            setError={setError}
            message={message}
            isEdit
          />
        ) : (
          <div className={classes.loading_container}>
            <CircularProgress color="primary" size={50} />
          </div>
        )}
      </>
    </Layout>
  );
}

export default AdminUpdatePage;
